<template>
  <div class="c-table">
    <el-table class="common-el-table-styles" ref="table" v-loading="loading" :data="data" height="100%" border stripe>
      <template slot="empty">
        <div class="empty">
          <img src="~assets/images/table-nodata.png" alt="" />
          <span>暂无数据</span>
        </div>
      </template>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'ruleType'">{{ scope.row[col.key] | ruletype }}</span>
          <template v-else-if="col.key === 'ruleConditionDesc'">
            <span style="display: block">{{ scope.row.dateType | datetype }}</span>
            <span>{{ scope.row[col.key] }}</span>
          </template>
          <div v-else-if="col.key === 'control'">
            <el-button type="text" size="small" @click="editClick(scope.row)">修改</el-button>
            <!-- <el-button type="text" size="small" @click="copyClick(scope.row)" class="c-control-margin">复制</el-button> -->
            <Poptip confirm transfer title="您确认删除该榜单规则吗？" @on-ok="delClick(scope.row)">
              <el-button type="text" size="small">删除</el-button>
            </Poptip>
          </div>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { delBillRule } from '@/api/material.model'
export default {
  name: 'ruleTable',
  props: {
    loading: {
      type: Boolean
    },
    data: {
      type: Array
    },
    columns: {
      type: Array
    }
  },
  data() {
    return {}
  },
  filters: {
    ruletype(cell) {
      if (cell === 1) return '优质榜'
      else if (cell === 2) return '潜力榜'
      else if (cell === 3) return '观察榜'
      else if (cell === 4) return '危险榜'
      else return '未知'
    },
    datetype(cell) {
      if (cell === 1) return '日数据'
      else if (cell === 2) return '周数据'
      else if (cell === 3) return '月数据'
      else return '未知'
    }
  },
  methods: {
    editClick(row) {
      const { ruleId } = row
      this.$emit('edit-rule', ruleId)
    },
    delClick(row) {
      const { ruleId } = row
      delBillRule({ ruleId }).then((data) => {
        if (data) this.$emit('on-refresh')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.c-table {
  height: 100%;

  .empty {
    width: 200px;
    margin: 0 auto;
  }

  .block-span {
    display: block;
  }

  .c-control-margin {
    margin: 0;
    padding: 0 3px;
  }

  .ivu-poptip {
    position: relative;

    .cover-mask {
      display: inline-block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      z-index: 3;
      cursor: pointer;
    }
  }
}
</style>
